import { isDefined, isNonEmptyString, reduceErrors, validate, ValidationErrors } from "../../util/validations"
export interface Refund {
  grossAmount?: number
  chargeId?: number
  includeFees?: boolean
  reference?: string
  method: "stripe" | "manual"
  participationId?: number
  reason?: string
}

export function newRefund(props: Refund): Refund {
  return {
    method: "",
    includeFees: false,
    reference: "",
    reason: "",
    ...props,
  }
}

export function validateRefund(data: Refund, maxRefundableAmount: number | undefined): ValidationErrors<Refund> {
  return reduceErrors({
    grossAmount: [
      validate(isDefined(data.grossAmount), "This doesn't look like a valid amount"),
      validate(data.grossAmount > 0, "The amount must be greater than 0"),
      isDefined(maxRefundableAmount) &&
        validate(data.grossAmount <= maxRefundableAmount, "This is more than you can refund for this charge"),
    ],
    chargeId: [validate(isDefined(data.chargeId), "You must select a charge to refund")],
    reference: [
      data.method === "manual" &&
        validate(isNonEmptyString(data.reference), "You must provide a reference for manual refunds"),
    ],
    participationId: [validate(isDefined(data.participationId), "You must select a passenger to refund")],
    reason: [validate(isNonEmptyString(data.reason), "You must provide a reason why you're issuing this refund")],
  })
}
